




























































































































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { toAVAX } from '@/helper'
import Subnet from '@/js/Subnet'
import { AVALANCHE_SUBNET_ID } from '@/store/modules/platform/platform'
import { IValidator } from '@/store/modules/platform/IValidator'
import ContentMetadata from '@/components/Subnets/ContentMetadata.vue'
import { scaleLinear } from 'd3-scale'
import { AVAX_ID } from '@/known_assets'

@Component({
    components: {
        ContentMetadata,
    },
    filters: {
        AVAX(val: number) {
            return parseFloat(toAVAX(val).toFixed(9)).toLocaleString()
        },
    },
})
export default class ValidatorDataTable extends Vue {
    defaultSubnetID: string = AVALANCHE_SUBNET_ID
    currentTime: number | null = null
    startTimes: number[] = []
    endTimes: number[] = []
    minTime = 0
    maxTime = 1
    absolute = false
    diagramWidth = 125
    expanded: any[] = []
    search = ''
    filteredCount = 0

    @Prop() subnetID!: string
    @Prop() subnet!: Subnet
    @Prop() validators!: IValidator[]
    @Prop() title!: string

    get headers(): any[] {
        return [
            {
                text: 'Delegator Payout Address',
                value: 'rewardOwner.addresses[0]',
                width: 420,
            },
            { text: 'Delegated Stake', value: 'stakeAmount', width: 175 },
            { text: 'Potential Reward', value: 'potentialReward', width: 150 },
            { text: 'Start', value: 'startTime', align: 'end', width: 80 },
            {
                text: 'Completion',
                value: 'elapsed',
                align: 'center',
                width: 125,
            },
            { text: 'End', value: 'endTime', width: 80 },
            { text: 'Duration', value: 'duration', width: 85 },
            { text: 'Delegate Node', value: 'nodeID', width: 420 },
        ]
    }

    get mode(): string {
        return this.absolute ? 'absolute' : 'relative'
    }

    get modeText() {
        return this.absolute ? 'Timeline' : 'Completion'
    }

    get nativeSymbol() {
        return this.$store.state.assets[AVAX_ID].symbol
    }

    created() {
        const now = new Date()
        this.currentTime = now.getTime()
        this.minTime = this.minStartTime()
        this.maxTime = this.maxEndTime()
    }

    minStartTime() {
        const startTimes: number[] = []
        this.subnet.validators.forEach((v: IValidator) => {
            startTimes.push(v.startTime.getTime())
        })
        return Math.min(...startTimes)
    }

    maxEndTime() {
        const endTimes: number[] = []
        this.subnet.validators.forEach((v: IValidator) => {
            endTimes.push(v.endTime.getTime())
        })
        return Math.max(...endTimes)
    }

    scale(val: number) {
        const scale = scaleLinear()
            .domain([this.minTime, this.maxTime])
            .range([0, this.diagramWidth])
        return scale(val)
    }

    scaleRelative(val: number) {
        const scale = scaleLinear().domain([0, 1]).range([0, this.diagramWidth])
        return scale(val)
    }
}
